import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { MyStore, reducers, connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { history } from 'kts-platform-frame/routes';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import TotalModulesAction from '../Modules.Action';
import { Carousel, Button } from 'antd';
import { guide } from 'src/api';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    /** 跑马灯 */
    slider = null;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        // 走马灯设置
        const settings = {
            dots: false,
        };
        const images = [
            {
                url: './image/old.png',
                className: 'old',
            }
        ];
        return (
            <div>
                <Carousel ref={el => (this.slider = el)} {...settings}>
                    {
                        images.map((element, index) => {
                            return (
                                <div className={css.guideSingle} key={index}>
                                    <div className={css.panel}>
                                        <img src={require(`${element.url}`)} />
                                        <div className={`${css.next} old`}>
                                            <Button onClick={() => this.toNew()} className={css.submit}>立即体验</Button>
                                            <Button onClick={() => this.cancel()} className={css.cancel}>取消</Button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </Carousel>
            </div>
        );
    }
    /** 立即体验 */
    private toNew = () => {
        MyStore.instance.dispatch(reducers.system.ActionTypes.setVersion, '0.3');
        history.push(`/workbench/m/kingxunlian.workbench`);
    }

    /** 取消体验新版 */
    private cancel = async () => {
        const { user } = MyStore.instance.getState();
        const res = await guide.updateGuideVersion(this, {
            guideVersion: TotalModulesAction.modulesState.GUIDE_VERSION,
            gUserId: user.userInfo.gUserId,
        });
        if (!res.er && res.res) {
            history.push(`/workbench/myApp`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Guide/UI.Old.tsx